import MachproHTMLElement from './common/machproHtmlElement';
import Image from './Image';

export default class ImageBackgroundComponent extends HTMLElement {
  constructor() {
    super();
    console.log('constructor ImageBackgroundComponent', super.src);
  }
  static get observedAttributes() {
    return ['src'];
  }
  getRealSrcPath(src: string) {
    if (!src) {
      // console.log('aaa', src);
      return src;
    }
    if (src.indexOf('assets://') !== -1) {
      return src.replace('assets://', `${process_env_PUBLIC_PATH}assets/`);
    } else if (src.indexOf('/assets/') !== -1) {
      return src.replace('/assets/', `${process_env_PUBLIC_PATH}assets/`);
    } else {
      return src;
    }
  }
  connectedCallback() {
    // super.connectedCallback();
    this.updateBackgroundImage();
  }
  updateBackgroundImage() {
    const src = this.getAttribute('src');
    const realSrc = this.getRealSrcPath(src);
    if (realSrc) {
      this.style.backgroundImage = `url(${realSrc})`;
      this.style.backgroundSize = 'cover';
      this.style.backgroundPosition = 'center';
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'src') {
      this.updateBackgroundImage();
    }
  }
}
